<template>
    <div>
        <div v-html="html"
             style="line-height: 10.39mm;letter-spacing: -0.4pt;word-break: break-all;font-family: 仿宋_GB2312;font-size: 16pt">
        </div>
    </div>
</template>

<script>
    export default {
        name: "DocContent",
        props: {
            html: {}
        }
    }
</script>